import React, { useEffect, useRef } from 'react';
import '../styles/PopupMenu.css';

const PopupMenu = ({ anchor, options, onClose, className }) => {
    const menuRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target) && anchor && !anchor.contains(event.target)) {
                onClose();
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [anchor, onClose]);

    if (!anchor) return null;

    return (
        <>
            <div className="popup-overlay" onClick={onClose}></div>
            <div className={className ? "popup-menu "+className : "popup-menu"} ref={menuRef}>
                {options.map((option, index) => (
                    <div key={index} className="popup-menu-item" onClick={option.onClick}>
                        {option.label}
                    </div>
                ))}
            </div>
        </>
    );
};

export default PopupMenu;